// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartViewerAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartViewerAction - common actions for all report part in standalone report part`
 */
!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var mapProps = require('recompose').mapProps;
  var { omit, times, constant } = require('lodash/fp');

  var action = compose(
    withHandlers({
      needUpdatePreview: function(props) {
        var store = props.store;

        return store.updatePreviewData.bind(store, props.subReportFilter);
      },
      getDrillDownRecords: function(props) {
        var store = props.store;

        return store.getPreviewData.bind(store, props.subReportFilter);
      },
      // don't need filter info for this case
      // for embeded report we will not have fillter value to pass for next sub report
      getFilterInfoForSubReport: function(props) {
        return function() {
          return {};
        };
      }
    }),
    mapProps(function(props) {
      return omit(['store'], props);
    })
  );

  module.exports = action;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartFrontSideViewer/Izenda.ReportPartFrontSideViewerAction.js